import React from 'react'
import { Link } from 'react-router-dom'
import VendorMapDetails from './../components/VendorMapDetails'

import { Container } from 'react-bootstrap'

const VendorDashboard = () => {
	return (
		<div className="vendDash py-5">
			<Container className="text-center ">
				<div className="col">
					<h3> Below is a map of your nearest customers based on appointments you set</h3> 
					<h4>Please add  
						<Link className="link" to="/vendorAppointments"> appointments </Link> 
						
					to see map changes.</h4>
					<p>Please refresh page if map doesn't load immediately.</p>
				</div>
			</Container>
			<VendorMapDetails/>

		</div>

	)
}
			
						
				
		




export default VendorDashboard